<template>
  <b-card title="Edit Kiosk PO">
    <b-modal v-model="disableButton" centered no-close-on-backdrop hide-footer hide-header>
      <div class="d-flex flex-column align-items-center justify-content-center py-3">
        <b-spinner medium variant="primary" label="Spinning"></b-spinner>
        <p class="mt-3">Processing Purchase Order</p>
      </div>
    </b-modal>
    
    <!-- Stock Check Loading Modal -->
    <b-modal v-model="checkingStock" centered no-close-on-backdrop hide-footer hide-header>
      <div class="d-flex flex-column align-items-center justify-content-center py-3">
        <b-spinner medium variant="primary" label="Spinning"></b-spinner>
        <p class="mt-3">Checking Stock Availability</p>
      </div>
    </b-modal>
    
    <!-- Stock Error Modal -->
    <b-modal v-model="showStockErrorModal" title="Stock Check Errors" ok-only>
      <b-list-group>
        <b-list-group-item v-for="(error, index) in stockErrorArray" :key="index" variant="danger">
          <strong>{{ error.itemModel }}:</strong> {{ error.message }}
        </b-list-group-item>
      </b-list-group>
    </b-modal>
    
    <b-modal v-model="modalConfirmation" :title="modalTitle">
      <!-- Alert before Delete PO-->
      <b-container>
        <b-row>
          <b-col cols="12" >
            <div class="d-flex">
              Are you sure want to {{ messageModal }} this {{form.PONumber}} ?
            </div>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-center align-items-center">
          <b-button variant="danger" class="ml-1" @click="confirmEdit">Confirm</b-button>
        </div>
      </template>
    </b-modal>
    
    <!-- Item Detail Modal -->
    <b-modal v-model="showItemDetailModal" :title="detailModalTitle" size="lg">
      <div v-if="selectedItemDetail">
        <b-card>
          <h5>Item Details</h5>
          <b-row>
            <b-col md="4"><strong>Model:</strong></b-col>
            <b-col>{{ selectedItemDetail.itemModel }}</b-col>
          </b-row>
          <b-row>
            <b-col md="4"><strong>Description:</strong></b-col>
            <b-col>{{ selectedItemDetail.description }}</b-col>
          </b-row>
          <b-row>
            <b-col md="4"><strong>Price:</strong></b-col>
            <b-col>{{ formatter(selectedItemDetail.price) }}</b-col>
          </b-row>
          <b-row>
            <b-col md="4"><strong>Requested Quantity:</strong></b-col>
            <b-col>{{ selectedItemDetail.qty }}</b-col>
          </b-row>
          <b-row>
            <b-col md="4"><strong>Available Quantity:</strong></b-col>
            <b-col>{{ selectedItemDetail.availableQty !== 0 && !selectedItemDetail.availableQty ? "Checking Stock" : selectedItemDetail.availableQty }}</b-col>
          </b-row>
        </b-card>
        
        <b-card v-if="selectedItemDetail.replacementItem && selectedItemDetail.status === 'Replacement Item Safe'" class="mt-3" border-variant="warning">
          <h5>Replacement Item</h5>
          <b-row>
            <b-col md="4"><strong>Model:</strong></b-col>
            <b-col>{{ selectedItemDetail.replacementItem.itemModel }}</b-col>
          </b-row>
          <b-row>
            <b-col md="4"><strong>Description:</strong></b-col>
            <b-col>{{ selectedItemDetail.replacementItem.description }}</b-col>
          </b-row>
          <b-row>
            <b-col md="4"><strong>Price:</strong></b-col>
            <b-col>{{ formatter(selectedItemDetail.priceReplacement) }}</b-col>
          </b-row>
          <b-row>
            <b-col md="4"><strong>Available Quantity:</strong></b-col>
            <b-col>{{ selectedItemDetail.availableReplacementQty !== 0 && !selectedItemDetail.availableReplacementQty ? "Checking Stock" : selectedItemDetail.availableReplacementQty }}</b-col>
          </b-row>
        </b-card>
      </div>
      <template #modal-footer>
        <b-button variant="secondary" @click="showItemDetailModal = false">Close</b-button>
      </template>
    </b-modal>
    
    <b-col cols="12">
      <b-row>
        <b-col>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Assign Discount to All Items">
                <b-row align-v="center">
                  <b-col cols="12" sm="4" lg="3">
                    <b-input-group>
                      <b-form-input
                        v-model="currentDiscount"
                        type="number"
                        min="0"
                        :max="maxDiscountValue"
                        placeholder="Enter discount"
                        class="text-right"
                      ></b-form-input>
                      <b-input-group-append is-text>%</b-input-group-append>
                      <b-input-group-append>
                        <b-button variant="primary" @click="applyDiscountToAllItems">Apply</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-col>
                  <b-col cols="12" sm="8" lg="9" class="mt-2 mt-sm-0">
                    <ul class="list-unstyled mb-0">
                      <li><small class="text-muted">Maximum discount: {{ maxDiscountValue }}%</small></li>
                      <li><small class="text-muted">Highest item discount: {{ highestDiscount }}%</small></li>
                    </ul>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <b-form @submit.prevent="">
            <!--section displays to order item-->
            <div
              v-if="disableEdit"
            >
              <span style="color:red">*This item has not been checked for stock by the warehouse</span>
            </div>
            <br>
            <div class="cart__area-ekiosk">
              <div class="cart__area-body-ekiosk">
                <!-- Header Row -->
                <div class="cart__area-columns-ekiosk mb-1">
                  <span> Item<span style="color:red">(*)</span> </span>
                  <span> Description </span>
                  <span> Quantity </span>
                  <span> Unit Price </span>
                  <span> Discount </span>
                  <span> Discount Amount </span>
                  <span> Total Price </span>
                  <span> Notes </span>
                  <span> Actions </span>
                </div>

                <!-- Item Rows - with separation for replacement items -->
                <div
                  v-for="(item, index) in form.items"
                  :key="`item-${index}`"
                >
                  <!-- Original Item Row -->
                  <div
                    class="cart__area-columns-ekiosk"
                    :class="{
                      'out-of-stock-ekiosk': item.status === 'Out of Stock' || item.availableQty === 0,
                    }"
                  >
                    <!-- Item Selection -->
                    <div>
                      <label v-if="item.status === 'Out of Stock' || item.availableQty === 0" style="font-size: 12px; color: white;">
                        This item is out of stock
                      </label>
                      <v-select
                        class="style-chooser"
                        v-model="item.itemModel"
                        :options="searchItems"
                        :clearSearchOnSelect="true"
                        @search="ajaxSearch"
                        @input="(selected) => fillItemInfoForm(index, selected, item)"
                        :disabled="!industryTypeValid || item.status === 'Replacement Item Safe' || item.hasReplacement"
                      >
                        <template #option="{ description, itemModel }">
                          {{ itemModel }}
                          <br />
                          <cite style="font-size:8px">{{ description }}</cite>
                        </template>
                        <template #selected-option="{ option }">
                          <cite style="font-size:10px">{{ `${item.itemModel} - ${item.description}` }}</cite>
                        </template>
                      </v-select>
                    </div>
                    <div>
                      <span>
                        <b-button
                        size="sm"
                        variant="outline-info"
                        @click="showItemDetails(item, index)"
                        v-if="item.itemModel"
                      >
                        <b-icon-info-circle />
                      </b-button>
                      </span>
                    </div>

                    <!-- Quantity -->
                    <div>
                      <label v-if="item.status === 'Out of Stock' || item.availableQty === 0" style="font-size: 12px; color: white;">
                        Available: {{ item.availableQty !== 0 && !item.availableQty ? "Checking" : item.availableQty}}
                      </label>
                      <label v-else class="text-danger" style="font-size: 12px;">
                        Available: {{ item.availableQty !== 0 && !item.availableQty ? "Checking" : item.availableQty}}
                      </label>
                      <b-form-input
                        type="number"
                        v-model="item.updatedQty"
                        @input="changeItemInfoQty(index, item)"
                        :disabled="item.availableQty == 0 || item.status === 'Replacement Item Safe' || item.hasReplacement"
                      />
                    </div>

                    <!-- Unit Price -->
                    <div>
                      <b-form-input
                        type="number"
                        disabled
                        :value="formatter(item.price)"
                        style="text-align: right;"
                      />
                    </div>

                    <!-- Discount -->
                    <div>
                      <b-input-group>
                        <b-form-input
                          v-model="item.unitDiscount"
                          @input="changeItemInfoDiscount(index, item)"
                          :disabled="item.availableQty == 0 || item.status === 'Replacement Item Safe' || item.hasReplacement"
                          :max="maxDiscountValue"
                          style="text-align: right;"
                        />
                        <b-input-group-append is-text>%</b-input-group-append>
                      </b-input-group>
                    </div>

                    <!-- Discount Amount -->
                    <div>
                      <b-form-input
                        :value="getDiscountAmountDisplay(item, index)"
                        @input="onDiscountAmountInput(index, item, $event)"
                        @focus="startEditingDiscountAmount(index, item)"
                        @blur="finishEditingDiscountAmount(index, item)"
                        :disabled="item.availableQty == 0 || item.status === 'Replacement Item Safe' || item.hasReplacement"
                        type="number"
                        step="0.01"
                        style="text-align: right;"
                      />
                    </div>

                    <!-- Total Price -->
                    <div>
                      <b-form-input
                        type="number"
                        disabled
                        :value="formatter(parseFloat(item.totalPrice))"
                        style="text-align: right;"
                      />
                    </div>

                    <!-- Notes -->
                    <div>
                      <b-form-input
                        type="text"
                        v-model="item.note"
                        placeholder="Enter notes"
                        style="width: 100%;"
                        :disabled="item.availableQty == 0 || item.status === 'Replacement Item Safe' || item.hasReplacement"
                      />
                    </div>

                    <!-- Actions -->
                    <div>
                      <b-button
                        variant="danger"
                        @click="cartRemoveItem(item)"
                        :disabled="!industryTypeValid"
                      >
                        <b-icon-trash />
                      </b-button>
                    </div>
                  </div>

                  <!-- Replacement Item Row (only shown if there's a replacement) -->
                  <div
                    v-if="item.replacementItem && item.status === 'Replacement Item Safe'"
                    class="cart__area-columns-ekiosk replacement-safe-ekiosk"
                    :key="`replacement-${index}`"
                  >
                    <!-- Item Selection (non-editable for replacement) -->
                    <div>
                      <label style="font-size: 12px; color: white;">
                        This item is replacement item for {{ item.itemModel }}
                      </label>
                      <v-select
                        class="style-chooser"
                        v-model="item.replacementItem.itemModel"
                        :options="[]"
                        disabled
                      >
                        <template #selected-option>
                          <cite style="font-size:9px">{{ `${item.replacementItem.itemModel} - ${item.replacementItem.description}` }}</cite>
                        </template>
                      </v-select>
                    </div>
                    <div>
                      <span>
                        <b-button
                        size="sm"
                        variant="outline-info"
                        @click="showItemDetails(item, index)"
                        v-if="item.itemModel"
                      >
                        <b-icon-info-circle />
                      </b-button>
                      </span>
                    </div>

                    <!-- Quantity -->
                    <div>
                      <label style="font-size: 12px; color: white;">
                        Available: {{ item.availableReplacementQty !== 0 && !item.availableReplacementQty ? "Checking" : item.availableReplacementQty }}
                      </label>
                      <b-form-input
                        type="number"
                        v-model="item.updatedReplacementQty"
                        @input="changeItemReplacementInfoQty(index, item)"
                        :disabled="item.availableReplacementQty == 0"
                      />
                    </div>

                    <!-- Unit Price -->
                    <div>
                      <b-form-input
                        type="number"
                        disabled
                        :value="formatter(item.priceReplacement)"
                        style="text-align: right;"
                      />
                    </div>

                    <!-- Discount -->
                    <div>
                      <b-input-group>
                        <b-form-input
                          v-model="item.unitDiscountReplacement"
                          @input="changeItemInfoDiscountReplacement(index, item)"
                          :disabled="item.availableReplacementQty == 0"
                          :max="maxDiscountValue"
                          style="text-align: right;"
                        />
                        <b-input-group-append is-text>%</b-input-group-append>
                      </b-input-group>
                    </div>

                    <!-- Discount Amount -->
                    <div>
                      <b-form-input
                        :value="getDiscountAmountReplacementDisplay(item, index)"
                        @input="onDiscountAmountReplacementInput(index, item, $event)"
                        @focus="startEditingDiscountAmountReplacement(index, item)"
                        @blur="finishEditingDiscountAmountReplacement(index, item)"
                        :disabled="item.availableReplacementQty == 0"
                        type="number"
                        step="0.01"
                        style="text-align: right;"
                      />
                    </div>

                    <!-- Total Price -->
                    <div>
                      <b-form-input
                        type="number"
                        disabled
                        :value="formatter(parseFloat(item.totalPriceReplacement))"
                        style="text-align: right;"
                      />
                    </div>

                    <!-- Notes -->
                    <div>
                      <b-form-input
                        type="text"
                        v-model="item.noteReplacement"
                        placeholder="Enter replacement notes"
                        style="width: 100%;"
                        :disabled="item.availableReplacementQty == 0"
                      />
                    </div>

                    <!-- Actions -->
                    <div>
                      <!-- No action button for replacement items -->
                    </div>
                  </div>
                </div>

                <!-- Totals Section -->
                <div class="cart__area-info-ekiosk mt-3">
                  <div class="cart__area-line-info-ekiosk">
                    <span>Subtotal after discount</span>
                    <b-form-input
                      :value="formatter(cartTotalPrice)"
                      placeholder="Total Price"
                      disabled
                      style="text-align: right;"
                    ></b-form-input>
                  </div>

                  <div class="cart__area-line-info-ekiosk">
                    <span>GST {{ currentGST.value }}%</span>
                    <b-form-input
                      :value="formatter(gstTotal)"
                      placeholder="GST"
                      disabled
                      style="text-align: right;"
                    ></b-form-input>
                  </div>

                  <div class="cart__area-line-info-ekiosk">
                    <span>Total Price</span>
                    <b-form-input
                      :value="formatter(cartTotal)"
                      placeholder="Cart Total"
                      disabled
                      style="text-align: right;"
                    ></b-form-input>
                  </div>
                </div>
                
                <!-- Error messages -->
                <div
                  ref="errorPage"
                  tabindex="-1"
                  id="stock-error"
                  class="alert alert-danger py-1"
                  v-if="stockError.length > 0"
                >
                  <ul>
                    <li
                      v-for="(error, index) in Object.values(stockError)"
                      :key="index"
                    >
                      {{ error }}
                    </li>
                  </ul>
                </div>

                <!-- Add item button -->
                <b-button
                  @click="cartAddItem"
                  class="my-2"
                  variant="outline-success"
                  :disabled="!industryTypeValid"
                >
                  Add Item
                </b-button>
                
                <!-- Bundle Modal -->
                <b-modal v-model="showBundleModal" title="Choose Bundle">
                  <b-container>
                    <b-row>
                      <b-col sm="3">
                        Bundle Set
                      </b-col>
                      <b-col cols="9">
                        <b-form-select v-model="selectedBundle">
                          <option
                            v-for="(selectOption, indexOpt) in filterBundle"
                            :key="indexOpt"
                            :value="selectOption"
                          >
                            {{ selectOption.name }}
                          </option>
                        </b-form-select>
                      </b-col>
                      
                    </b-row>
                    <b-row>
                      <b-col sm="3">
                        Bundle Quantity
                      </b-col>
                      <b-col cols="9">
                        <b-form-input
                          v-model="bundleQuantity"
                          type="number"
                          placeholder="Enter Bundle Qty"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-container>

                  <template #modal-footer>
                    <b-button variant="success" @click="cartAddBundle">
                      Confirm
                    </b-button>

                    <b-button
                      variant="danger"
                      @click="showBundleModal = false"
                    >
                      Cancel
                    </b-button>
                  </template>
                </b-modal>
              </div>
            </div>
            
            <!-- Mobile view removed for brevity -->
            
            <div>
              <b-form-group>
              
                <span
                  >Name
                  <span v-if="mandatoryStatus" style="color:red"
                    >(*)</span
                  ></span
                >
                <b-form-input
                  maxlength="40"
                  v-model="form.customer.firstName"
                  style="margin-top:5px !important;"
                  type="text"
                  placeholder="Enter Name"
                ></b-form-input>
              </b-form-group>

              <!-- <b-form-group>
                <span
                  >Phone
                  <span v-if="mandatoryStatus" style="color:red"
                    >(*)</span
                  ></span
                >
                <b-form-input
                  v-model="form.customer.phone"
                  style="margin-top:5px !important;"
                  type="text"
                  placeholder="Enter Phone"
                ></b-form-input>
              </b-form-group> -->

              <b-form-group>
                <span>Email</span>
                <b-form-input
                  v-model="form.customer.email"
                  style="margin-top:5px !important;"
                  type="email"
                  placeholder="Enter Email"
                ></b-form-input>
              </b-form-group>

              <b-form-group>
                <span>PO Number</span>
                <b-form-input
                  v-model="form.PONumber"
                  disabled
                  style="margin-top:5px !important;"
                  type="text"
                  placeholder="PO Number"
                ></b-form-input>
              </b-form-group>

              <b-form-group v-if="isDealerOrder()">
                <span>Industry Type<span style="color:red">(*)</span></span>
                <v-select
                  v-model="selectedIndustryTypeForKiosk"
                  placeholder="----- Select Industry Types -----"
                  :options="industryTypeOption"
                  :clearable="false"
                  style="margin-top:5px !important;"
                  class="mb-1"
                >
                </v-select>
              </b-form-group>

              <b-form-group v-if="isDealerOrder()">
                <span>Customer PO</span>
                <b-form-input
                  v-model="form.customerPO"
                  style="margin-top:5px !important;"
                  type="text"
                  placeholder="Enter Customer PO"
                  @input="validateInput"
                ></b-form-input>
              </b-form-group>

              <b-form-group v-if="!isDealerOrder()">
                <span
                  >Payment Type
                  <span v-if="mandatoryStatus" style="color:red"
                    >(*)</span
                  ></span
                >
                <b-form-select
                  v-model="form.paymentType"
                  :options="paymentOption"
                >
                </b-form-select>
              </b-form-group>
              
              <b-form-group>
                <span>Remarks<span style="color:red"> (Can input up to 155 characters)</span></span>
                <b-form-textarea
                v-model="form.remarks"
                style="margin-top:5px !important;"
                placeholder="Remarks"
                rows="4"
                max-rows="10"
                @input.native="remarksMaxHandler"
                ></b-form-textarea>
              </b-form-group>

            </div>
            <div
              v-if="disableConfirm"
              class="mb-1"
            >
              <span style="color:red">*Can not Submit PO if there is no stock item</span>
            </div>
            <b-button
              @click="editKioskPurchaseOrder"
              type="button"
              variant="warning"
              class="mr-1"
              :disabled="disableButton"
              >Check Stock and Discount Approval</b-button
            >
            <b-button
              @click="cancelOrder"
              type="button"
              variant="danger"
              class="mr-1"
              :disabled="disableButton"
              >Cancel PO</b-button
            >
             <!-- <b-button
              @click="submitKioskPurchaseOrder"
              type="submit"
              variant="success"
              class="mr-1"
              disabled
              >Submit Kiosk PO</b-button
            > -->
          </b-form>
        </b-col>
      </b-row>
    </b-col>
  </b-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import axios from "@/axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import lodash from "lodash";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { sleep } from "@/utils/utils.js";
import { BIconInfoCircle, BIconTrash } from 'bootstrap-vue';
// import { isRaw } from "@vue/composition-api";

export default {
  components: {
    "date-picker": DatePicker,
    "v-select": vSelect,
    "b-icon-info-circle": BIconInfoCircle,
    "b-icon-trash": BIconTrash
  },
  data() {
    return {
      //form to save data

      //discount assign handler
      currentDiscount: 0,
      highestDiscount: 0,

      // Item detail modal properties
      showItemDetailModal: false,
      detailModalTitle: "Item Details",
      selectedItemDetail: null,
      
      // Stock error modal properties
      showStockErrorModal: false,
      stockErrorArray: [],

      // Editing state for discount amounts - avoiding $set issues on items
      editingStates: {
        discountAmounts: {},        // { itemKey: { editing: true, tempValue: '10.50' } }
        discountAmountsReplacement: {}
      },

      form: {
        deliveryType: "SOSC", //default form will be self collect
        customer: {
          type: "Individual",
          companyName: "",
          firstName: "",
          lastName: "",
          address: "",
          address2: "",
          address3: "",
          buildingName: "",
          phone: "",
          email: "",
          postal: "",
          city: "Singapore",
          //detail address
          street: "",
          block: "",
          floor: "",
          number: "",
          //detail address
        },
        items: [{ itemModel: "", description: "" }],
        deliveryDate: "",
        orderType: "SELF_COLLECT_AMK", //default form will be self collect
        //save total
        subTotal: 0,
        tax: 0,
        totalPrice: 0,
        //end save total
        timeslot: null,
        addressType: "",
        priority: "",
        distributionChannel:"",
        paymentType:"",
        deliveryCity: "",
        deliveryPostal: "",
        deliveryPhone: "",
        deliveryEmail: "",
        deliveryAddress: "",
        deliveryAddress2: "",
        deliveryAddress3: "",
        deliveryInstruction: "",
        dealer: "",
        customerPO : "",
        remarks:"",
        PONumber:"",
        approvalToken:""
      },
      modalConfirmation :false,
      modalTitle :'',
      messageModal :'',
      replacementMessage: "",
      editQtyMessage:"",
      selectedIndustryType:"",
      selectedIndustryTypeForKiosk:"DL",
      industryTypeOption:['DL','DJ','DS'],
      industryTypeValid:false,
      // mandatory for Address Type "Default Address"
      mandatoryStatus: true,
      flagInputPrice : false,
      flagInputPriceReplacement : false,
      // state for Delivery Block No and Delivery Unit No fields appear or not
      doBlockandUnitFieldsState: false,
      changeItem : false,

      //end of form to save data
      stockError: {},
      item: null,
      itemQty: 0,
      // warehouses: [],
      promptDraft: false,
      orderTypes: [
        { value: "DELIVERY", text: "Delivery" },
      ],
      deliveryTypeOptions: [
        { value: "SOEC", text: "End Customer" },
        { value: "SOWH", text: "Internal Warehouse Delivery" },
      ],
      paymentOption: [
        { value: 'CASH', text: 'Paynow' },
        { value: 'NETS', text: 'Nets' },
        { value: 'MC', text: 'Credit Card Master Card' },
        { value: 'VISA', text: 'Credit Card Visa' }
      ],
      addBy: "item",
      addItemByOptions: [
        { value: "item", text: "Item" },
        { value: "bundle", text: "Bundle" },
        { value: "category", text: "Category" },
      ],
      optionAddress: ["Default Address", "New Delivery Address"],
      categoriesOptions: [],
      category: null,
      categoryItems: [],
      categoryItem: null,
      timestate: null,
      holidays: [],
      today: 0,
      deliveryDate: "",
      showBundleModal: false,
      selectedBundle: null,
      bundleQuantity:1,
      publishedItems: [],
      timeslotOptions: [],
      timeslotTemplate:[
        "10 AM to 12 noon",
        "2 PM to 5 PM",
        "6 PM onwards",
      ],
      searchItems: [],
      ajaxItem: null,
      arrayStreet: [],
      arrayBuildingName: [],
      dealerChoice: "", //This is if dealer doesn't detect at active user
      computedItemsResult: [], // hasil akhir dari item yang dihitung
      //button disable
      disableButton: false,
      disableEdit :false,
      disableConfirm: false,
      dataPO: "",
      replacementOptions: {},
      checkingStock: false, // Flag for stock checking modal 
    };
  },
  watch: {
    form: {
      handler() {
        this.computeItems();
      },
      deep: true
    }
  },
  mounted() {
    

    this.getDiscountForEkioskEdit()
    this.computeItems();
    let idKioskPO = this.$route.params.idKioskPO;
    // Create an array of promises to track all async operations
    const promises = [
      this.listBundles(),
      this.getHolidays(),
      this.$store.dispatch("dealer/getAllDealers"),
      this.$store.dispatch("auth/fetchUser"),
      this.$store.dispatch("GST/getCurrentGST")
    ];
    
    // Set today's date
    let now = new Date();
    this.today = Number.parseInt(String(now.getDate()).padStart(2, "0"));
    
    // Wait for all promises to resolve, then get current dealer and finally call detailPurchase
    Promise.all(promises)
      .then(() => {
        // Call detailPurchase only after all other operations are complete
        this.detailPurchase(idKioskPO);
      })
      .catch(error => {
        console.error("Error in initialization sequence:", error);
      });

    
  },
  methods: {
    ...mapActions({
      getAddressByPostal: "mapAPI/getAddressByPostal",
      addKioskPo: "purchase/addKioskPo",
      editKioskPo: "purchase/editKioskPo",
      savePurchaseDraft: "purchase/savePurchaseDraft",
      listBundles: "item/listItemBundle",
      getItemsForDealer: "item/getDealerKioskItemToOrder",
      getItemReplacementForDealer: "item/getDealerItemReplacementToOrder",
      editStatusPO: 'purchase/editStatusKioskPo',
      checkStock: "sendSAP/checkStock",
      addSaleKiosk: "sales/addSaleKiosk",
      getGeneralDiscount: "discount/getGeneralDiscount",
      getDiscountForEkioskEdit: "discount/getDiscountForEkioskEdit"
    }),
    isDealerOrder(){
      return this.form.PONumber && this.form.PONumber.startsWith("EKR");
    },
    remarksMaxHandler(){
      if(this.form.remarks.length>155){
        this.form.remarks = this.form.remarks.substring(0, 155);
      }
    },
    applyDiscountToAllItems() {
      // Validate discount is within range
      if (this.currentDiscount < 0) {
        this.currentDiscount = 0;
      } else if (this.currentDiscount > this.maxDiscountValue) {
        this.currentDiscount = this.maxDiscountValue;
      }
      
      // Apply discount to all eligible items
      this.form.items.forEach((item, index) => {
        // Apply to regular items with available quantity
        if ((item.availableQty > 0 || (item.availableQty !== 0 && !item.availableQty)) && !item.hasReplacement) {
          item.unitDiscount = parseFloat(this.currentDiscount);
          
          // Calculate regular item values
          const quantity = item.updatedQty || item.qty;
          const discountAmount = (item.price * (item.unitDiscount / 100)) * quantity;
          const totalPrice = (item.price - (item.price * (item.unitDiscount / 100))) * quantity;
          
          item.discountAmount = this.formatter(discountAmount);
          item.totalPrice = this.formatter(totalPrice);
        }
        
        // Apply to replacement items with available quantity
        if (item.replacementItem && 
            (item.availableReplacementQty > 0 || (item.availableReplacementQty !== 0 && !item.availableReplacementQty))) {
          item.unitDiscountReplacement = parseFloat(this.currentDiscount);
          
          // Calculate replacement item values
          const quantity = item.updatedReplacementQty || item.availableReplacementQty || 1;
          const discountAmount = (item.priceReplacement * (item.unitDiscountReplacement / 100)) * quantity;
          const totalPrice = (item.priceReplacement - (item.priceReplacement * (item.unitDiscountReplacement / 100))) * quantity;
          
          item.updatedReplacementQty = quantity;
          item.discountAmountReplacement = this.formatter(discountAmount);
          item.totalPriceReplacement = this.formatter(totalPrice);
        }
      });
      
      // Update highest discount if needed
      if (parseFloat(this.currentDiscount) > this.highestDiscount) {
        this.highestDiscount = parseFloat(this.currentDiscount);
      }
      
      // Trigger recomputation
      this.computeItems();
    },
    async addAddressByPostal(postal){
      if(postal.length!=6){
        this.$bvToast.toast(`Postal not valid`, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        return;
      }
      var address;
      try{
        address = await this.getAddressByPostal(postal);
      }catch(err){
        this.$bvToast.toast(`One Map API Returns Error`, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        return;
      }

      if(address.length<=0){
        this.$bvToast.toast("Postal "+postal+" has no address", {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        return;
      }
      var arrayStreet=[];
      var arrayBuildingName=[];
      var arrayBlockNumber=[];
      for (let postalData of address) {
        let { ROAD_NAME,BLK_NO,BUILDING } = postalData;
        arrayStreet.push(ROAD_NAME);
        arrayBuildingName.push(BUILDING);
        arrayBlockNumber.push(BLK_NO);

      }
      let newSetArrayStreet = [...new Set(arrayStreet)];
      let newSetArrayBuildingName = [...new Set(arrayBuildingName)];
      let newSetArrayBlockNumber = [...new Set(arrayBlockNumber)];

      if (newSetArrayStreet.length > 1) {
        this.arrayStreet = newSetArrayStreet;
        this.isStreetArray = true;
      } else {
        this.form.customer.street = newSetArrayStreet[0];
        this.isStreetArray = false;
      }
      if (newSetArrayBuildingName.length > 1) {
        this.arrayBuildingName = newSetArrayBuildingName;
        this.isBuildingNameArray = true;
      } else {
        this.form.customer.buildingName = newSetArrayBuildingName[0];
        this.isBuildingNameArray = false;
      }
      if(newSetArrayBlockNumber.length==1){
        this.form.customer.block= newSetArrayBlockNumber[0];
      }

      this.$bvToast.toast(`Address found`, {
        title: "Success",
        variant: "success",
        solid: true,
      });
    },
    getItemList(payload) {
      return new Promise((resolve,reject)=>{
        this.getItemsForDealer(payload).then((data) => {
          this.searchItems = 
          data
          .filter((distItem) => {
            const productHierarchy = distItem.item.productHierarchy;
            return (
              productHierarchy.startsWith("10000") ||
              productHierarchy.startsWith("05100") ||
              productHierarchy.startsWith("05300")
            );
          })
          .map((distItem) => {
            //handling item catalog only show at list when status = "" (Active)
            //NEW rule, show at list when price is above 0
            if (distItem.item.status === "") {
              //parse number decimal price
              distItem.price = parseFloat(distItem.price.$numberDecimal);
              //temporary use this for better price filter by distribution channel
              return {
                label: `${distItem.item.itemModel} - ${distItem.item.description}`,
                description: distItem.item.description,
                itemModel: distItem.item.itemModel,
                ...distItem,
              };
            }
          });
          this.industryTypeValid=true
          resolve(true)
        }).catch((err)=>{

          let { response } = err;
          this.searchItems=[];
          this.industryTypeValid=false
          
          this.$bvToast.toast(response.data.errors[0].message, {
            title: "Failed",
            variant: "danger",
            solid: true,
          });
          reject(err)
        });
      })
      
    },
    formatter(value) {
      let number = value;
      if (typeof value === 'object' && value.$numberDecimal) {
        number = parseFloat(value.$numberDecimal);
      } else if (typeof value === 'string') {
        number = parseFloat(value) || 0;
      } else if (!number) {
        number = 0;
      }
      return (Math.round(number * 100) / 100).toFixed(2);
    },
    emptyDealer() {
      this.mandatoryStatus = true;
      this.form.deliveryType = "SOEC";
      this.dealerChoice = "";
      this.form.customer.address = "";
      this.form.customer.email = "";
      this.form.customer.postal = "";
      this.form.customer.phone = "";
      this.form.customer.firstName = "";
      this.form.customer.street = "";
      this.form.customer.block = "";
      this.form.customer.buildingName = "";
    },
    async setDetailPurchase(response){
        var timeslotTemp = response.data.data.timeslot;
        let data = response.data.data;
        this.selectedIndustryType = data.distributionChannel;
        var itemPriceGet = await this.getItemList({
          industryType: this.selectedIndustryType,
        });
        if(!itemPriceGet){
          this.$bvToast.toast(`Getting Item price error, please refresh page toretry`, {
            title: "Failed",
            variant: "danger",
            solid: true,
          });
        }
        //end detail delivery
        let tempItem = [];
        var itemIndex;
        var priceTemp;
        var priceReplacementTemp;
        for (let item of data.items) {
          itemIndex = this.searchItems.findIndex((x)=>{
            if(x==undefined){
              return false
            }
            return x.item._id === item.id && x.channel._id === item.channel
          })
          priceTemp= parseFloat(item.price.$numberDecimal)

          if(item.replacementItem){
            priceReplacementTemp = parseFloat(item.priceReplacement.$numberDecimal)
          }
          if (itemIndex>=0){
            priceTemp = this.searchItems[itemIndex].price
          }

          // Calculate discount amounts based on saved unitDiscount values
          const unitDiscount = item.unitDiscount || 0;
          const unitDiscountReplacement = item.unitDiscountReplacement || 0;
          const quantity = item.qty || 0;
          const quantityReplacement = item.status === "Replacement Item Safe" ? item.qty : 0;

          // Calculate discount amount for regular item
          const discountAmount = (priceTemp * (unitDiscount / 100)) * quantity;

          // Calculate discount amount for replacement item if applicable
          const discountAmountReplacement = item.replacementItem && item.status === "Replacement Item Safe" 
            ? (priceReplacementTemp * (unitDiscountReplacement / 100)) * quantityReplacement 
            : 0;

          tempItem.push({
            ...item,
            qty: item.qty,

            //if item has replacement or is out of stock, set updatedQty to 0
            updatedQty: (item.status == "Replacement Item Safe" || item.status == "Out of Stock") ?0: 
            item.availableReplacementQty ? item.availableReplacementQty : item.qty, // Ensure updatedQty is set from qty
            updatedReplacementQty: (item.status == "Replacement Item Safe") ? item.qty : 0,
            price: priceTemp,
            priceReplacement: (item.status == "Replacement Item Safe") ? priceReplacementTemp : 0,
            totalPrice: priceTemp * item.qty, // Use qty directly for calculation
            itemModel: item.model,
            model: item.model,
            description: item.description,
            channel: item.channel,
            id: item.id,
            unitDiscount: unitDiscount,
            unitDiscountReplacement: unitDiscountReplacement,
            discountAmount: this.formatter(discountAmount),
            discountAmountReplacement: this.formatter(discountAmountReplacement),
          });
        }
        
        
        // Create a new form object first, then assign customer separately to ensure reactivity
        this.form = {...data} ;
        this.form.customer = data.customerDetail
        // Make a deep copy of the customer object to ensure it's reactive
        //this.form.customer = JSON.parse(JSON.stringify(data.customer));
        //set all value manually to object
        
        this.form.items = tempItem;
        
        // Calculate totals after setting form data
        this.$nextTick(() => {
          this.computeItems();
        });
    },
    async detailPurchase(idSale) {
      //ini buat load detail dari purchase order ini berdasarkan id nya
      axios
        .get(`sales-and-purchase/purchase/detail/${idSale}`)
        .then( (response) => {
          this.setDetailPurchase(response);
          this.dataPO = response.data.data

          if(this.dataPO.orderStatus!="Editing" && this.dataPO.orderStatus!=""){
            var counterID = localStorage.getItem("lastCounterID")||''
            if(counterID!=''){
              this.$router.push({ name: 'counter-view', 
              params: { id: counterID } });
            }else{
              this.$router.push({ name: 'kiosk-po-counter' });
            }
          }

          // Mark items with replacements
          this.markItemsWithReplacements();
        })
        .catch((e) => {
          console.error(e);
        });
    },
    
    // Add new method to mark items with replacements
    markItemsWithReplacements() {
      this.form.items.forEach(item => {
        // Mark items that have replacement items as having replacements
        if (item.replacementItem && Object.keys(item.replacementItem).length > 0 && item.status === 'Replacement Item Safe') {
          item.hasReplacement = true;
          item.updatedReplacementQty = item.availableReplacementQty??item.updatedQty??item.qty??1;
        }
      });
    },
    displayDate(date) {
      //ini untuk tampilan informasi tanggal dibawah form date picker nya
      var result = moment(date).format("YYYY-MM-DD");
      return result;
    },
    setTimeslotOption(date){
      //ini logic buat datepicker
      // Rule 1: Delivery Or Collect Date For Today Is Disable
      // Rule 2: Delivery Can Only Happen Next Day Or The Day After
      // Rule 3: Time Slot Option Is Tied To Time When Order Created
      // Rule 4: Time Order Created After Afternoon (18:00-00:00) Timeslot Available Is Next Day Morning
      // Rule 5: Time Order Created At Morning (00:00 - 12:00) Timeslot Available Is Afternoon Slot Next Day
      // Rule 6: Saturday (Half Day ?) And Sunday Is Off Day (No Delivery Happen Here)
      // Rule 7: If Today Is Friday And Choose Delivery Date At Saturday Only Morning Slot Available
      
      //new rule - July 2024
      /**
       *  1. Self Collect can be processed at the same timeslot (ie. If order in Monday Morning, then self collection can also be done in Monday Morning)
          2. If order is done after 5 PM, then self collect can be done by the next morning
          3. Delivery can be processed as soon as two days after order time (ie. If order in Monday Morning, then delivery can be done as soon as Wednesday Morning)
          a. by the same rule, If customer want to order and to have the items be delivered before the week ends (Sunday), then customer have to order before Thursday Afternoon
       */

      //resetting timeslot
      this.form.timeslot="";

      let selectedTime = moment(date);
      let selectedDay = selectedTime.days();
      let selectedDate = selectedTime.date();

      let now = moment();
      let currentHour = now.format("HH");
      let currentDay = now.days();
      let currentDate = now.date()
      let isDelivery = (this.form.orderType=='DELIVERY');

      let epoch = moment('1970-01-01')
      let nowToEpoch = now.diff(epoch,'days')
      let selectedToEpoch = selectedTime.diff(epoch,'days')


      if(isDelivery){
        //
        if(selectedDay==6){
          this.timeslotOptions=[this.timeslotTemplate[0]]
          return;
        }
        if((selectedToEpoch-nowToEpoch==2)&& currentHour>=12){
          this.timeslotOptions=[this.timeslotTemplate[1],this.timeslotTemplate[2]]
          return;
        }
        this.timeslotOptions=this.timeslotTemplate
        return;

      }else{
        //self collect
        //if selected is saturday
        if(selectedDay==6){
          this.timeslotOptions=[this.timeslotTemplate[0]]
          return;
        }

        if(selectedDay==currentDay && currentHour>=12){
          this.timeslotOptions=[this.timeslotTemplate[1]]
          return;
        }
        //return all
        this.timeslotOptions= [this.timeslotTemplate[0],this.timeslotTemplate[1]]
        return;
      }

    },
    defineIndustryType(){
      this.form.items= [{ itemModel: "", description: "" }]
      this.getItemList({
        industryType: this.selectedIndustryType,
      });
    },
    defineDealer() {
      //ini buat mencocokan item price master dilihat dari distribution channelnya apakah sama dengan industry Type dealer yg login atau dealer yang dipilih
      this.industryTypeOption= [this.dealerChoice.industryType]

      if(this.dealerChoice.secondIndustryType!=undefined&&this.dealerChoice.secondIndustryType!=""){
        this.industryTypeOption.push(this.dealerChoice.secondIndustryType)
      }

      this.form.items= [{ itemModel: "", description: "" }]
      this.selectedIndustryType= this.dealerChoice.industryType
      this.getItemList({
        industryType: this.selectedIndustryType,
      });
      // this.getItemList({
      //   industryType: this.dealerChoice.industryType,
      // });
      /*
      this.getItemsForDealer().then((data) => {
        this.searchItems = data.map((distItem) => {
          //handling item catalog only show at list when status = "" (Active)
          //NEW rule, show at list when price is above 0
          if (distItem.item.status === "") {
            //parse number decimal price
            distItem.price = parseFloat(distItem.price.$numberDecimal);
            //temporary use this for better price filter by distribution channel
            return {
              label: `${distItem.item.itemModel} - ${distItem.item.description}`,
              description:distItem.item.description,
              itemModel:distItem.item.itemModel,
              ...distItem,
            };
          }
        });
      });
      */
    },
    //ini buat waktu ketik postal code kalo ada data yg tersimpan (di collection drccpostalinfos) buat auto load informasi lainnya
    autoFillAddress: lodash.debounce(function(a) {
      // console.log('this.itemDatabase', this.itemsDatabase)
      let arrayStreet = [];
      let arrayBuildingName = [];
      axios
        .get(`sales-and-purchase/drcc/postal-info`, {
          params: {
            postal: a,
          },
        })
        .then((response) => {
          let data = response.data.data;
          for (let postalData of data) {
            let { street, buildingName } = postalData;
            arrayStreet.push(street);
            arrayBuildingName.push(buildingName);
          }
          let newSetArrayStreet = [...new Set(arrayStreet)];
          let newSetArrayBuildingName = [...new Set(arrayBuildingName)];

          if (newSetArrayStreet.length > 1) {
            this.arrayStreet = newSetArrayStreet;
            this.isStreetArray = true;
          } else {
            this.form.customer.street = newSetArrayStreet[0];
            this.isStreetArray = false;
          }
          if (newSetArrayBuildingName.length > 1) {
            this.arrayBuildingName = newSetArrayBuildingName;
            this.isBuildingNameArray = true;
          } else {
            this.form.customer.buildingName = newSetArrayBuildingName[0];
            this.isBuildingNameArray = false;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }, 500),
    getHolidays() {
      //ambil data hari liburan buat date picker
      axios
        .get("sales-and-purchase/holidays/range")
        .then((response) => {
          this.holidays = response.data.data.map((d) => {
            let date = new Date(d.holidayDate);
            return {
              month: date.getMonth(),
              day: Number.parseInt(String(date.getDate()).padStart(2, "0")),
            };
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    addItem() {
      //buat nambahin baris item list
      if (this.addBy === "bundle") {
        for (let i of this.item.items) {
          this.form.items.push({
            model: i.itemModel,
            qty: this.itemQty,
          });
        }

        return;
      }

      this.form.items.push({
        model: this.item,
        qty: this.itemQty,
      });
    },
    async editKioskPurchaseOrder() {
      //ini waktu klik confirm purchase dimana akan kirim PO ke SAP. dengan sebelumnya akan check stock dulu per item
      //for handling dealer info

      var itemsToSAP = this.form.items.map(item => {
        // If item has a replacement and status is Replacement Item Safe, use replacement data
        if (item.replacementItem && item.status === 'Replacement Item Safe') {
          return {
            model: item.replacementItem.itemModel,
            qty: item.updatedReplacementQty ?? item.availableReplacementQty
          };
        } else {
          // Otherwise use original item data
          return {
            model: item.model,
            qty: item.updatedQty ?? item.qty
          };
        }
      });

      try {
        // Show the stock checking modal
        this.checkingStock = true;
        
        var checkStopApi = await this.checkStock({sloc:'01',items:itemsToSAP})
        
        // Hide the stock checking modal
        this.checkingStock = false;
        
        if (!checkStopApi.success) {
          this.$bvToast.toast(`Item is out of stock`, {
            title: "Failed",
            variant: "danger",
            solid: true,
          });
          this.disableButton = false;
          return;
        }
      } catch (error) {
        // Hide the stock checking modal
        this.checkingStock = false;
        
        console.log(error);
        var errorObject = error.response.data.error;
        this.stockErrorArray = Object.entries(errorObject).map(([itemModel, message]) => ({
          itemModel,
          message
        }));
        
        // Show the stock error modal instead of a simple toast
        this.showStockErrorModal = true;
        
        this.$bvToast.toast(`Error checking stock - see details in the modal`, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        this.disableButton = false;
        return;
      }
      
      
      this.disableButton = true;

      if (this.getDealer && this.getDealer != "") {
        //if user is dealer
        this.form.dealer = this.getDealer;
      } else {
        //if user is not dealer
        this.form.dealer = this.dealerChoice;
      }


      for (const [index,value] of this.form.items.entries()) {
        // validation for make sure there is at least 1 item in items list
      for (const [index,value] of this.form.items.entries()) {
        if(!value.model||value.model=="" ) {
          this.$bvToast.toast(`Please select item model on Item number `+(index+1), {
            title: "Failed",
            variant: "danger",
            solid: true,
          });
          this.disableButton = false;
          return; 
        } 
        
        if(!value.qty||value.qty==0 ) {
          this.$bvToast.toast(`Item quantity cannot empty on Item number `+(index+1), {
            title: "Failed",
            variant: "danger",
            solid: true,
          });
          this.disableButton = false;
          return;
        } 
      }  
      }

      if(this.form.customer.firstName == ""){
        this.$bvToast.toast(`Please Add Name`, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        this.disableButton = false;
        // Prevent Any Saving Data From Run
        return;
      }

      if(this.form.customer.phone == "" && this.form.orderType === 'DELIVERY' && this.form.deliveryType === 'SOEC'){
        this.$bvToast.toast(`Please Add Phone Number`, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        this.disableButton = false;
        // Prevent Any Saving Data From Run
        return;
      }

      if(this.form.customer.email == "" && this.form.orderType === 'DELIVERY' && this.form.deliveryType === 'SOEC'){
        this.$bvToast.toast(`Please Add Email`, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        this.disableButton = false;
        // Prevent Any Saving Data From Run
        return;
      }

      //save total
      this.form.subTotal = this.cartTotal;
      this.form.tax = this.gstTotal;
      this.form.totalPrice = this.cartTotalPrice;
      this.form.totalDiscount = this.cartTotalDiscount
      this.form.highestDiscount = this.highestDiscount
      //end save total

      //this industryType
      this.form.distributionChannel = this.selectedIndustryTypeForKiosk
      await this.getGeneralDiscount().then((data) => {
        let discount
        if (data) {
          discount = data.value
        }else{
          discount = 0
        }
        if (this.highestDiscount > discount) {
          this.form.orderStatus = "Awaiting Discount Approval"
        }else{
          this.form.orderStatus = "Checking"
          
          this.form.items = this.form.items.map(el => {
            return {
              ...el,
              status : ""
            }
          })
        }
      })
      let mFormCopy = JSON.parse(JSON.stringify(this.form));
      if (mFormCopy.items.length <= 0) {
        this.$bvToast.toast("Please Add Item First", {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        this.disableButton = false;
        return;
      }

      this.editKioskPo(mFormCopy)
        .then(async (response) => {
          var isChecking = response.orderStatus === "Checking";

          var message = isChecking ? "Edit Kiosk Purchase Order Successfully. Stock is being checked" : 
          "Edit Kiosk Purchase Order Successfully";

          this.$bvToast.toast("Edit Kiosk Purchase Order Successfully", {
            title: "Success",
            variant: "success",
            solid: true,
          });
          this.disableButton = false;
          sessionStorage.setItem("toastMessage", "Edit Kiosk Purchase Order Successfully");
          this.$router.push({ name: 'kiosk-po-detail', params:{id:this.$route.params.idKioskPO} });
        })
        .catch(async (e) => {
          this.disableButton = false;   
          this.$bvToast.toast(e.response.data.message || "Edit Kiosk Purchase Order Failed", {
              title: "Failed",
              variant: "danger",
              solid: true,
            });
          await sleep(2000);
          // this.$router.push({ name: "order" });
        });
    },

    filterDisableDate(date, arrayDate) {
      let day = date.getDay()
      let epoch = moment('1970-01-01');
      let selectedDate = moment(date);
      let now = moment();
      let selectedToEpoch = selectedDate.diff(epoch,'days')
      let nowToEpoch = now.diff(epoch,'days')
      let currentHour = now.format("HH");
      let yesterday=now.subtract(1, 'days')
      //current hour is based on local time

      var isDelivery =(this.form.orderType=='DELIVERY')

      //console.filter disable Date

      //Disable before today
      if (date <= yesterday) {
        return true;
      }


      // Disable All Sunday Days
      // No Delivery On Sunday
      if (day === 0) {
        return true;
      }

      //
      
      // Disable Delivery Today, and tommorow
      let checkedDay = Number.parseInt(String(date.getDate()).padStart(2, "0"));
      if ((selectedToEpoch-nowToEpoch<=1)&& isDelivery) {
        return true;
      }

      //If time is already night & order type is Self Collect
      if (currentHour>17&&!isDelivery&& checkedDay == this.today){
        return true;
      }
      
      //if today is saturday & time is passed 12 pm
      if(currentHour>12&&!isDelivery&& day==6 && selectedToEpoch-nowToEpoch==0){
        return true;
      }

      // Disable Holiday Day
      let month = date.getMonth();
      let checkElem = this.holidays.filter((h) => {
        if (h.month == month && h.day == checkedDay) {
          return true;
        }

        return false;
      });
      if (checkElem.length > 0) {
        return true;
      }
      // End Disable Holiday Day

      return false;
    },
    fillItemInfoForm(index, selectedData, cartItem) {
      //ini waktu setelah milih list price dan item dan otomatis mengisi field lainnya yang dibutuhkan
      var quantityTemp = cartItem.qty;
      var quantityAvailable = cartItem.updatedQty ? cartItem.updatedQty : quantityTemp;
      const unitDiscount = cartItem.unitDiscount || 0;
      
      let data;
      
      if (!selectedData.item) {
        // Calculate discount amount and total price
        const price = parseFloat(selectedData.price);
        const discountAmount = price * (unitDiscount / 100) * quantityAvailable;
        const totalPrice = (price - (price * (unitDiscount / 100))) * quantityAvailable;
        
        data = {
          ...cartItem,
          description: selectedData.description,
          price: this.formatter(price),
          qty: quantityTemp,
          totalPrice: this.formatter(totalPrice),
          itemModel: selectedData.itemModel,
          model: selectedData.itemModel,
          id: selectedData._id,
          channel: selectedData.channel,
          discountAmount: this.formatter(discountAmount),
          unitDiscount: parseFloat(unitDiscount)
        };
      } else {
        // Calculate discount amount and total price
        const price = parseFloat(selectedData.price);
        const discountAmount = price * (unitDiscount / 100) * quantityAvailable;
        const totalPrice = (price - (price * (unitDiscount / 100))) * quantityAvailable;
        
        data = {
          ...cartItem,
          description: selectedData.item.description,
          price: this.formatter(price),
          qty: quantityTemp,
          totalPrice: this.formatter(totalPrice),
          itemModel: selectedData.item.itemModel,
          model: selectedData.item.itemModel,
          id: selectedData.item._id,
          channel: selectedData.channel,
          discountAmount: this.formatter(discountAmount),
          unitDiscount: parseFloat(unitDiscount)
        };
      }
      
      // Clean up unnecessary properties
      delete data.availableQty;
      delete data.availableReplacementQty;
      delete data.replacementItem;
      delete data.status;
      
      // Apply to form items
      this.form.items.splice(cartItem.parentIndex, 1, data);
      this.changeItem = true;
      
      // Recalculate everything
      this.computeItems();
    },
    changeItemInfoQty(index, cartItem) {
      //ini otomatis perhitungan waktu qty per item diubah
      this.updateItemCalculations(index, cartItem, false, true); // Pass quantityChanged flag
    },

    changeItemReplacementInfoQty(index, cartItem) {
      //ini otomatis perhitungan waktu qty per item diubah
      this.updateItemCalculations(index, cartItem, false, true); // Pass quantityChanged flag
    },

    changeItemInfoDiscount(index, cartItem) {
      this.flagInputPrice = true;
      this.updateItemCalculations(index, cartItem, true, false); // unitDiscountChanged = true, quantityChanged = false


      
      // Update highest discount if needed
      // only apply if item is not replacement
      if (parseFloat(cartItem.unitDiscount) > this.highestDiscount && !cartItem.hasReplacement) {
        this.highestDiscount = parseFloat(cartItem.unitDiscount); 
      }
    },

    changeItemInfoDiscountReplacement(index, cartItem) {
      this.flagInputPriceReplacement = true;
      this.updateItemCalculations(index, cartItem, true, false); // unitDiscountChanged = true, quantityChanged = false
      
      // Update highest discount if needed
      if (parseFloat(cartItem.unitDiscountReplacement) > this.highestDiscount) {
        this.highestDiscount = parseFloat(cartItem.unitDiscountReplacement);
      }
    },

    changeItemInfoDiscountAmount(index, cartItem) {
      // Legacy method - redirect to new system
      this.flagInputPrice = true;
      
      // Calculate unit discount percentage from discount amount
      const quantity = cartItem.updatedQty || cartItem.qty || 0;
      const price = this.parseToNumber(cartItem.price);
      const discountAmount = this.parseToNumber(cartItem.discountAmount);
      
      if (price > 0 && quantity > 0) {
        // Calculate unit discount percentage: (discountAmount / (price * quantity)) * 100
        const calculatedUnitDiscount = (discountAmount / (price * quantity)) * 100;
        
        // Check if calculated discount exceeds maximum allowed
        if (calculatedUnitDiscount > this.maxDiscountValue) {
          // Limit discount amount to maximum allowed
          const maxAllowedDiscountAmount = (price * quantity * this.maxDiscountValue) / 100;
          cartItem.discountAmount = this.formatter(maxAllowedDiscountAmount);
          cartItem.unitDiscount = this.maxDiscountValue;
          
          this.$bvToast.toast(`Discount amount limited to maximum allowed discount of ${this.maxDiscountValue}%`, {
            title: "Discount Limited",
            variant: "warning",
            solid: true,
          });
        } else {
          cartItem.unitDiscount = Math.round(calculatedUnitDiscount * 100) / 100;
        }
      }
      
      this.updateItemCalculations(index, cartItem, false, false); // Neither unitDiscount nor quantity changed
      
      // Update highest discount if needed
      const currentDiscount = parseFloat(cartItem.unitDiscount || 0);
      if (currentDiscount > this.highestDiscount && !cartItem.hasReplacement) {
        this.highestDiscount = currentDiscount;
      }
    },

    changeItemInfoDiscountAmountReplacement(index, cartItem) {
      // Legacy method - redirect to new system
      this.flagInputPriceReplacement = true;
      
      // Calculate unit discount percentage from discount amount for replacement item
      const quantity = cartItem.updatedReplacementQty || cartItem.availableReplacementQty || 0;
      const price = this.parseToNumber(cartItem.priceReplacement);
      const discountAmount = this.parseToNumber(cartItem.discountAmountReplacement);
      
      if (price > 0 && quantity > 0) {
        // Calculate unit discount percentage: (discountAmount / (price * quantity)) * 100
        const calculatedUnitDiscount = (discountAmount / (price * quantity)) * 100;
        
        // Check if calculated discount exceeds maximum allowed
        if (calculatedUnitDiscount > this.maxDiscountValue) {
          // Limit discount amount to maximum allowed
          const maxAllowedDiscountAmount = (price * quantity * this.maxDiscountValue) / 100;
          cartItem.discountAmountReplacement = this.formatter(maxAllowedDiscountAmount);
          cartItem.unitDiscountReplacement = this.maxDiscountValue;
          
          this.$bvToast.toast(`Replacement discount amount limited to maximum allowed discount of ${this.maxDiscountValue}%`, {
            title: "Discount Limited",
            variant: "warning",
            solid: true,
          });
        } else {
          cartItem.unitDiscountReplacement = Math.round(calculatedUnitDiscount * 100) / 100;
        }
      }
      
      this.updateItemCalculations(index, cartItem, false, false); // Neither unitDiscount nor quantity changed
      
      // Update highest discount if needed
      const currentDiscount = parseFloat(cartItem.unitDiscountReplacement || 0);
      if (currentDiscount > this.highestDiscount) {
        this.highestDiscount = currentDiscount;
      }
    },

    updateItemCalculations(index, cartItem, unitDiscountChanged = false, quantityChanged = false) {
      // Directly update the input field value to enforce the maximum
      if (parseFloat(cartItem.unitDiscount) > this.maxDiscountValue) {
        cartItem.unitDiscount = this.maxDiscountValue;
        this.$bvToast.toast(`Discount limited to maximum allowed discount of ${this.maxDiscountValue}%`, {
            title: "Discount Limited",
            variant: "warning",
            solid: true,
          });
      }
      if (parseFloat(cartItem.unitDiscountReplacement) > this.maxDiscountValue) {
        cartItem.unitDiscountReplacement = this.maxDiscountValue;
        this.$bvToast.toast(`Discount limited to maximum allowed discount of ${this.maxDiscountValue}%`, {
            title: "Discount Limited",
            variant: "warning",
            solid: true,
          });
      }

      // Ensure discount doesn't exceed maximum
      const unitDiscount = parseFloat(cartItem.unitDiscount || 0) <= this.maxDiscountValue 
        ? parseFloat(cartItem.unitDiscount || 0) 
        : this.maxDiscountValue;
      
      const unitDiscountReplacement = parseFloat(cartItem.unitDiscountReplacement || 0) <= this.maxDiscountValue 
        ? parseFloat(cartItem.unitDiscountReplacement || 0) 
        : this.maxDiscountValue;
      
      // Calculate for normal item with no replacement
      if (!cartItem.hasReplacement && cartItem.status !== 'Replacement Item Safe') {
        const quantity = cartItem.updatedQty || cartItem.updatedQty === 0 ? cartItem.updatedQty : cartItem.qty;
        const price = this.parseToNumber(cartItem.price);
        
        // Handle discount calculation based on what changed
        let finalDiscountAmount = 0;
        let finalUnitDiscount = unitDiscount;
        
        if (unitDiscountChanged) {
          // If unit discount changed, recalculate discount amount
          finalDiscountAmount = (price * (unitDiscount / 100)) * quantity;
          finalUnitDiscount = unitDiscount;
        } else if (quantityChanged) {
          // If quantity changed, preserve the discount percentage and recalculate discount amount
          finalUnitDiscount = unitDiscount; // Keep existing percentage
          finalDiscountAmount = (price * (finalUnitDiscount / 100)) * quantity;
        } else {
          // If neither changed, preserve existing discount amount
          finalDiscountAmount = this.parseToNumber(cartItem.discountAmount) || 0;
          // Recalculate unit discount percentage based on preserved discount amount
          const totalPriceBeforeDiscount = price * quantity;
          if (totalPriceBeforeDiscount > 0 && finalDiscountAmount > 0) {
            finalUnitDiscount = (finalDiscountAmount / totalPriceBeforeDiscount) * 100;
          }
        }
        
        // Calculate total price: (price * quantity) - discountAmount
        const totalPriceBeforeDiscount = price * quantity;
        const totalPrice = totalPriceBeforeDiscount - finalDiscountAmount;
        
        let updatedCartItem = {
          ...cartItem,
          unitDiscount: finalUnitDiscount,
          discountAmount: this.formatter(finalDiscountAmount),
          totalPrice: this.formatter(totalPrice),
          status: '',
          availableQty: cartItem.availableQty
        };
        
        if (this.changeItem) {
          updatedCartItem.qty = quantity;
        }
        
        this.form.items.splice(cartItem.parentIndex, 1, updatedCartItem);
      } 
      // Calculate for replacement item
      else if (cartItem.replacementItem && cartItem.status === 'Replacement Item Safe') {
        const quantity = cartItem.updatedReplacementQty || cartItem.updatedReplacementQty === 0 
          ? cartItem.updatedReplacementQty 
          : cartItem.availableReplacementQty;
        const price = this.parseToNumber(cartItem.priceReplacement);
        
        // Handle discount calculation based on what changed
        let finalDiscountAmount = 0;
        let finalUnitDiscount = unitDiscountReplacement;
        
        if (unitDiscountChanged) {
          // If unit discount changed, recalculate discount amount
          finalDiscountAmount = (price * (unitDiscountReplacement / 100)) * quantity;
          finalUnitDiscount = unitDiscountReplacement;
        } else if (quantityChanged) {
          // If quantity changed, preserve the discount percentage and recalculate discount amount
          finalUnitDiscount = unitDiscountReplacement; // Keep existing percentage
          finalDiscountAmount = (price * (finalUnitDiscount / 100)) * quantity;
        } else {
          // If neither changed, preserve existing discount amount
          finalDiscountAmount = this.parseToNumber(cartItem.discountAmountReplacement) || 0;
        }
        
        // Calculate total price based on: (price * quantity) - discountAmount
        const totalPrice = (price * quantity) - finalDiscountAmount;
        
        let updatedCartItem = {
          ...cartItem,
          updatedReplacementQty: quantity,
          unitDiscountReplacement: finalUnitDiscount,
          discountAmountReplacement: this.formatter(finalDiscountAmount),
          totalPriceReplacement: this.formatter(totalPrice),
          hasReplacement: true
        };
        
        this.form.items.splice(cartItem.parentIndex, 1, updatedCartItem);
      }
      
      this.computeItems();
    },
    cartRemoveItem(cartItem) {
      //ini buat hapus 1 baris item list detail
      
      // Clean up editing state before removing item
      this.cleanupItemEditingState(cartItem.parentIndex, cartItem);
      
      this.form.items.splice(cartItem.parentIndex, 1);
      this.computeItems(); // Recompute after removing
    },
    cartAddItem() {
      //ini buat tambah 1 baris item list detail
      this.form.items.push({ 
        itemModel: "", 
        description: "", 
        qty: 1, 
        updatedQty: 1,
        price: 0, 
        totalPrice: 0, 
        unitDiscount: 0, 
        discountAmount: 0,
        availableQty: undefined,
        status: "",
        isReplacement: false
      });
    },
    cartAddBundle() {
      
      //ini waktu setelah keluar popup untuk pilih bundle list item, akan ada button confirm. dan dimasukkan ke list item detail pesanan
      let { items, channel } = this.selectedBundle;
      var multiplier =(typeof this.bundleQuantity !="number")?parseInt(this.bundleQuantity):this.bundleQuantity

      if(multiplier<=0  || typeof multiplier !="number"){
        this.$bvToast.toast(`Please Enter Valid value for Bundle Quantity`, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        return;
      }

      //temporary save all selected item bundle list
      let tempItems = [];
      for (let i of items) {
        tempItems.push({
          qty: i.quantity*multiplier,
          price: parseFloat(i.price.$numberDecimal),
          totalPrice: parseFloat(i.price.$numberDecimal) * 1,
          label: `${i.itemModel} - ${i.id.description}`,
          description: i.id.description,
          itemModel: i.itemModel,
          model: i.itemModel,
          channel: channel._id,
          id: i.id._id,
        });
      }

      //replace if any empty index
      var checkInside = this.form.items.map((b) => {
        return Object.keys(b).length;
      });
      for (let a = 0; a < checkInside.length; a++) {
        if (checkInside[a] === 0) {
          this.form.items.splice(a, 1);
        }
      }

      //loop by temporary item bundle list to replace form po item list.
      for (let b of tempItems) {
        let searchIndex = this.form.items.findIndex((item) => {
          return item.id === b.id;
        });
        if (searchIndex < 0) {
          this.form.items.push({
            qty: b.qty,
            price: b.price,
            totalPrice: b.price * b.qty,
            label: `${b.itemModel} - ${b.description}`,
            description: b.description,
            itemModel: b.itemModel,
            model: b.itemModel,
            channel: channel._id,
            id: b.id,
          });
        } else {
          let qtyTemp= (typeof this.form.items[searchIndex].qty == "string")?
          parseInt(this.form.items[searchIndex].qty):this.form.items[searchIndex].qty
            this.form.items[searchIndex].qty = qtyTemp + b.qty;
          this.form.items[searchIndex].totalPrice =
            this.form.items[searchIndex].price *
            this.form.items[searchIndex].qty;
        }
      }

      this.selectedBundle = null;
      this.bundleQuantity = 1;
      this.showBundleModal = false;
    },
    datePicked(date) {
      //datePicked logic is moved to setTimeslotOption
      //enables trigger not by datepicker 
      this.setTimeslotOption(date);
    },
    ajaxSearch: lodash.debounce(function(search, loading) {
      loading(true);
      var currentDealer;
      if (this.getDealer && this.getDealer != "") {
        //if user is dealer
        currentDealer = this.getDealer;
      } else {
        //if user is not dealer
        currentDealer = this.dealerChoice;
      }
      var industryType = this.selectedIndustryType
      this.getItemsForDealer({
        industryType: industryType,
        item: search,
      })
        .then((data) => {
          this.searchItems = 
          data
          .filter((distItem) => {
            const productHierarchy = distItem.item.productHierarchy;
            return (
              productHierarchy.startsWith("10000") ||
              productHierarchy.startsWith("05100") ||
              productHierarchy.startsWith("05300")
            );
          })
          .map((item) => {
            //handling item catalog only show at list when status = "" (Active)

            if (item.item.status === "") {
              item.price = parseFloat(item.price.$numberDecimal);
              return {
                label: `${item.item.itemModel} - ${item.item.description}`,
                description: item.item.description,
                itemModel: item.item.itemModel,
                ...item,
              };
            }
          });

          loading(false);
        })
        .catch((e) => {
          console.log(e);
        });
    }, 500),
    ajaxItemSelected(item) {
      this.ajaxItem = item;
    },
    validateInput(event) {
      const value = event.target.value;
      // Allow all alphanumeric & special case, except -
      const regex = /[*]/;
      if (regex.test(value)) {
        this.$bvToast.toast(`Inserting '*' in Customer PO is not allowed. Please use '/' instead`, {
          title: "Failed",
          variant: "danger",
          solid: true,
        });
        this.form.customerPO = value.replace('*', '');
      }
    },
    async getReplacementOptions(cartItem, index) {
      if (!cartItem.id) return;
      if(cartItem.replacementItem){ 
        try {
        const response = await axios.get(`sales-and-purchase/drcc/item/detail/${cartItem.replacementItem._id}`);
        let data = response.data.data
        
        // Simpan hasilnya ke state berdasarkan index-nya
        this.$set(this.replacementOptions, index, data || []);
      } catch (error) {
        console.error("Error fetching replacement items:", error);
        this.$set(this.replacementOptions, index, []); // Jika error, set kosong
      }
      }
      try {
        const response = await axios.get(`sales-and-purchase/drcc/item/detail/${cartItem.id}`);
        let data = response.data.data
        data.label = `${data.itemModel} = ${data.description}`
        // .map(el => {
        //   return {
        //     label: `${el.itemModel} - ${el.description}`,
        //     description: el.description,
        //     itemModel: el.itemModel,
        //     ...el,
        //   };
        // })
        
        // Simpan hasilnya ke state berdasarkan index-nya
        this.$set(this.replacementOptions, index, data.replacementItem || []);
      } catch (error) {
        console.error("Error fetching replacement items:", error);
        this.$set(this.replacementOptions, index, []); // Jika error, set kosong
      }
    },
    async computeItems() {
      this.disableEdit = false;
      this.disableConfirm = false;
      this.highestDiscount = 0;
      
      // Process each item directly
      for (const [index, item] of this.form.items.entries()) {
        // Check for stock status to determine if edit/submit should be disabled
        if (item.availableQty !== 0 && item.availableQty === undefined) {
          this.disableEdit = true;
        }
        else if(item.replacementItem && item.availableReplacementQty !== 0 && item.availableReplacementQty === undefined){
          this.disableEdit = true;
        }
        
        // Check if any items have zero stock to disable submission
        // For items with replacements, only check replacement stock
        if ((item.availableQty === 0 && !item.replacementItem) || 
            (item.replacementItem && item.availableReplacementQty === 0 && item.status === 'Replacement Item Safe')) {
          this.disableConfirm = true;
        }
        
        // Set parent index for reference
        item.parentIndex = index;
        
        // Ensure price is a number
        if (typeof item.price === 'object' && item.price.$numberDecimal) {
          item.price = parseFloat(item.price.$numberDecimal);
        }
        
        // Mark if item has replacement
        if (item.replacementItem && Object.keys(item.replacementItem).length > 0 && item.status === 'Replacement Item Safe') {
          item.hasReplacement = true;
        }
        
        // Process price calculations for regular items (without replacement or not using replacement)
        if (!item.hasReplacement || item.status !== 'Replacement Item Safe') {
          // Default to item.qty if updatedQty is not set
          const quantity = item.updatedQty !== undefined ? item.updatedQty : 
                           (item.qty !== undefined ? item.qty : 0);
          
          // Preserve manually entered discount amounts
          // If discountAmount exists and is valid, use it directly
          const existingDiscountAmount = this.parseToNumber(item.discountAmount) || 0;
          
          // Only recalculate discount amount if it's not manually set
          let finalDiscountAmount = existingDiscountAmount;
          if (existingDiscountAmount === 0 && item.unitDiscount > 0) {
            // Calculate discount amount from unit discount percentage only if no manual amount exists
            finalDiscountAmount = (item.price * (parseFloat(item.unitDiscount) / 100)) * quantity;
          }
          
          // Calculate total price: (price * qty) - discountAmount
          const totalPriceBeforeDiscount = item.price * quantity;
          const totalPrice = totalPriceBeforeDiscount - finalDiscountAmount;
          
          if (!this.flagInputPrice) {
            // Only update if it's not a direct price input
            item.totalPrice = this.formatter(totalPrice);
            item.discountAmount = this.formatter(finalDiscountAmount);
          } else if (typeof item.totalPrice === 'object' && item.totalPrice.$numberDecimal) {
            // Handle totalPrice as numberDecimal
            item.totalPrice = this.formatter(parseFloat(item.totalPrice.$numberDecimal));
          }
        }
        
        // Process price calculations for replacement items if applicable
        if (item.replacementItem && Object.keys(item.replacementItem).length > 0 && item.status === 'Replacement Item Safe') {
          // Fetch replacement item price if not already available
          if (!item.priceReplacement) {
            try {
              const data = await this.getItemReplacementForDealer({
                industryType: this.selectedIndustryType,
                item: item.replacementItem._id
              });
              if (data.data.length > 0) {
                item.priceReplacement = parseFloat(data.data[0].price?.$numberDecimal || "0");
              }
            } catch (error) {
              console.error("Failed to fetch replacement price:", error);
            }
          }
          
          // Calculate replacement item totals
          const quantity = item.updatedReplacementQty !== undefined ? item.updatedReplacementQty : 
                         (item.availableReplacementQty !== undefined ? item.availableReplacementQty : 0);
          const priceReplacement = parseFloat(item.priceReplacement.$numberDecimal || "0");
          this.priceReplacement = priceReplacement;
          
          // Preserve manually entered discount amounts for replacement items
          // If discountAmountReplacement exists and is valid, use it directly
          const existingDiscountAmount = this.parseToNumber(item.discountAmountReplacement) || 0;
          
          // Only recalculate discount amount if it's not manually set
          let finalDiscountAmount = existingDiscountAmount;
          if (existingDiscountAmount === 0 && item.unitDiscountReplacement > 0) {
            // Calculate discount amount from unit discount percentage only if no manual amount exists
            finalDiscountAmount = (item.priceReplacement * (parseFloat(item.unitDiscountReplacement) / 100)) * quantity;
          }
          
          // Calculate total price: (price * qty) - discountAmount
          const totalPriceBeforeDiscount = item.priceReplacement * quantity;
          const totalPrice = totalPriceBeforeDiscount - finalDiscountAmount;
          
          if (!this.flagInputPriceReplacement) {
            item.totalPriceReplacement = this.formatter(totalPrice);
            item.discountAmountReplacement = this.formatter(finalDiscountAmount);
            item.updatedReplacementQty = quantity;
          }
        }


        
        // Update highest discount value
        const itemDiscount = item.status === 'Replacement Item Safe' ? 
          (item.unitDiscountReplacement ? parseFloat(item.unitDiscountReplacement) : 0) : 
          (item.unitDiscount ? parseFloat(item.unitDiscount) : 0);
          
        if (itemDiscount > this.highestDiscount) {
          this.highestDiscount = itemDiscount;
        }
      }
      
      // Reset flags after computation
      this.flagInputPrice = false;
      this.flagInputPriceReplacement = false;
    },
    cancelOrder(row) {
      this.modalConfirmation = true
      this.modalTitle = "Cancel Kiosk PO"
      this.messageModal = "Cancel"
    },
    confirmEdit() {
      this.modalConfirmation = false
      let statusChange = 'Canceled'
      let payloadData = { status : statusChange}
      this.editStatusPO({ id : this.form._id, data : payloadData})
      .then(async (response) => {
        sessionStorage.setItem("toastMessage", "Cancel Kiosk Purchase Order Successfully");
        this.$router.push({ name: 'kiosk-po-counter' });
      })
      .catch(async (e) => {
        console.log(e);
        this.$bvToast.toast("Edit status Kiosk Purchase Order Failed", {
            title: "Failed",
            variant: "danger",
            solid: true,
          });
      });
    },
    showItemDetails(item, index) {
      this.selectedItemDetail = { ...item };
      this.detailModalTitle = `Item Details: ${item.itemModel}`;
      this.showItemDetailModal = true;
    },
    // Parse value to clean number for calculations
    parseToNumber(value) {
      try {
        if (typeof value === 'object' && value.$numberDecimal) {
          return parseFloat(value.$numberDecimal);
        }
        const parsed = parseFloat(value) || 0;
        if (isNaN(parsed)) {
          console.warn('Invalid number parsed:', value);
          return 0;
        }
        return parsed;
      } catch (error) {
        console.error('Error parsing number:', error);
        return 0;
      }
    },
    getDiscountAmountDisplay(item, index) {
      const key = this.getItemKey(index, item);
      const editState = this.editingStates.discountAmounts[key];
      
      if (editState && editState.editing) {
        return editState.tempValue !== undefined ? editState.tempValue : this.parseToNumber(item.discountAmount);
      }
      return this.formatter(item.discountAmount);
    },
    onDiscountAmountInput(index, item, value) {
      const key = this.getItemKey(index, item);
      const editState = this.editingStates.discountAmounts[key];
      
      if (editState && editState.editing) {
        editState.tempValue = value;
      } else {
        item.discountAmount = value;
        this.updateItemCalculations(index, item);
      }
    },
    startEditingDiscountAmount(index, item) {
      const key = this.getItemKey(index, item);
      // Use Vue.set for the editingStates object, not the item
      this.$set(this.editingStates.discountAmounts, key, {
        editing: true,
        tempValue: this.parseToNumber(item.discountAmount)
      });
    },
    finishEditingDiscountAmount(index, item) {
      const key = this.getItemKey(index, item);
      const editState = this.editingStates.discountAmounts[key];
      
      if (editState && editState.editing) {
        const inputValue = this.parseToNumber(editState.tempValue);
        
        // Validate against maximum allowed discount amount
        const quantity = item.updatedQty || item.qty || 0;
        const price = this.parseToNumber(item.price);
        const maxAllowedDiscountAmount = (price * quantity * this.maxDiscountValue) / 100;
        
        let finalDiscountAmount = inputValue;
        let finalUnitDiscount = 0;
        
        if (price > 0 && quantity > 0) {
          // Calculate unit discount percentage for validation and display
          finalUnitDiscount = (inputValue / (price * quantity)) * 100;
          
          // Check if calculated discount exceeds maximum allowed
          if (finalUnitDiscount > this.maxDiscountValue) {
            finalDiscountAmount = maxAllowedDiscountAmount;
            finalUnitDiscount = this.maxDiscountValue;
            
            this.$bvToast.toast(`Discount amount limited to maximum allowed discount of ${this.maxDiscountValue}%`, {
              title: "Discount Limited",
              variant: "warning",
              solid: true,
            });
          }
        }
        
        // Update the item with validated values
        // Preserve the exact discount amount entered by the user
        item.discountAmount = this.formatter(finalDiscountAmount);
        // Store unit discount with high precision to avoid recalculation issues
        item.unitDiscount = finalUnitDiscount;
        
        // Calculate total price directly from discount amount to avoid rounding errors
        const totalPriceBeforeDiscount = price * quantity;
        item.totalPrice = this.formatter(totalPriceBeforeDiscount - finalDiscountAmount);
        
        // Clean up editing state
        this.$delete(this.editingStates.discountAmounts, key);
        
        // Update highest discount if needed (use the actual unit discount for comparison)
        if (finalUnitDiscount > this.highestDiscount && !item.hasReplacement) {
          this.highestDiscount = finalUnitDiscount;
        }
        
        // Trigger overall computation without changing this item's values
        this.computeItems();
      }
    },
    getDiscountAmountReplacementDisplay(item, index) {
      const key = this.getItemKey(index, item);
      const editState = this.editingStates.discountAmountsReplacement[key];
      
      if (editState && editState.editing) {
        return editState.tempValue !== undefined ? editState.tempValue : this.parseToNumber(item.discountAmountReplacement);
      }
      return this.formatter(item.discountAmountReplacement);
    },
    onDiscountAmountReplacementInput(index, item, value) {
      const key = this.getItemKey(index, item);
      const editState = this.editingStates.discountAmountsReplacement[key];
      
      if (editState && editState.editing) {
        editState.tempValue = value;
      } else {
        item.discountAmountReplacement = value;
        this.updateItemCalculations(index, item);
      }
    },
    startEditingDiscountAmountReplacement(index, item) {
      const key = this.getItemKey(index, item);
      // Use Vue.set for the editingStates object, not the item
      this.$set(this.editingStates.discountAmountsReplacement, key, {
        editing: true,
        tempValue: this.parseToNumber(item.discountAmountReplacement)
      });
    },
    finishEditingDiscountAmountReplacement(index, item) {
      const key = this.getItemKey(index, item);
      const editState = this.editingStates.discountAmountsReplacement[key];
      
      if (editState && editState.editing) {
        const inputValue = this.parseToNumber(editState.tempValue);
        
        // Validate against maximum allowed discount amount
        const quantity = item.updatedReplacementQty || item.availableReplacementQty || 0;
        const price = this.parseToNumber(item.priceReplacement);
        const maxAllowedDiscountAmount = (price * quantity * this.maxDiscountValue) / 100;
        
        let finalDiscountAmount = inputValue;
        let finalUnitDiscount = 0;
        
        if (price > 0 && quantity > 0) {
          // Calculate unit discount percentage for validation and display
          finalUnitDiscount = (inputValue / (price * quantity)) * 100;
          
          // Check if calculated discount exceeds maximum allowed
          if (finalUnitDiscount > this.maxDiscountValue) {
            finalDiscountAmount = maxAllowedDiscountAmount;
            finalUnitDiscount = this.maxDiscountValue;
            
            this.$bvToast.toast(`Replacement discount amount limited to maximum allowed discount of ${this.maxDiscountValue}%`, {
              title: "Discount Limited",
              variant: "warning",
              solid: true,
            });
          }
        }
        
        // Update the item with validated values
        // Preserve the exact discount amount entered by the user
        item.discountAmountReplacement = this.formatter(finalDiscountAmount);
        // Store unit discount with high precision to avoid recalculation issues
        item.unitDiscountReplacement = finalUnitDiscount;
        
        // Calculate total price directly from discount amount to avoid rounding errors
        const totalPriceBeforeDiscount = price * quantity;
        item.totalPriceReplacement = this.formatter(totalPriceBeforeDiscount - finalDiscountAmount);
        
        // Clean up editing state
        this.$delete(this.editingStates.discountAmountsReplacement, key);
        
        // Update highest discount if needed (use the actual unit discount for comparison)
        if (finalUnitDiscount > this.highestDiscount) {
          this.highestDiscount = finalUnitDiscount;
        }
        
        // Trigger overall computation without changing this item's values
        this.computeItems();
      }
    },
    // Get unique key for item to track editing state
    getItemKey(index, item) {
      return `${index}_${item.id || item.itemModel || index}`;
    },
    
    // Clean up editing state for a specific item
    cleanupItemEditingState(index, item) {
      const key = this.getItemKey(index, item);
      if (this.editingStates.discountAmounts[key]) {
        this.$delete(this.editingStates.discountAmounts, key);
      }
      if (this.editingStates.discountAmountsReplacement[key]) {
        this.$delete(this.editingStates.discountAmountsReplacement, key);
      }
    },
  },
  computed: {
    ...mapGetters({
      itemsOptions: "item/itemsOptions",
      itemsBundles: "item/itemsBundles",
      currentGST: "GST/getCurrentGST",
      maxDiscount: "discount/getMaxDiscount",
    }),
    maxDiscountValue() {
      return this.maxDiscount && this.maxDiscount.value ? this.maxDiscount.value : 100;
    },
    generalDiscount() {
      let generalDiscount = this.$store.getters["discount/getGeneralDiscount"].value||0;
      return generalDiscount;
    },

    filterBundle() {
      //first step : filter all list bundle from collection by channel of dealer login
      var filterByChannel = this.itemsBundles.filter((x) => {
        return x.channel.name === this.getDealer.industryType;
      });

      //second step : search in each list bundle whether there are items that are not active from *filterByChannel* array
      //because if there is only 1 item is not active, then the bundle items are also inactive
      let findInactiveItems = filterByChannel.filter(({ items = [] }) =>
        items.some(({ id }) => id.status !== "")
      );

      //third step : Find values that are in filterByChannel but not in findInactiveItems
      var activeBundle = filterByChannel.filter(function(obj) {
        return !findInactiveItems.some(function(obj2) {
          return obj._id == obj2._id;
        });
      });

      return activeBundle;
    },
    user() {
      //buat cek informasi akun yang sedang login
      return this.$store.getters["auth/getActiveUser"];
    },
    dealer() {
      return this.$store.getters["dealer/getDealers"].filter(
        (x) => x.status === ""
      );
    },
    getDealer() {
      //ini buat cek apakah akun yang sedang login termasuk dealer atau bukan
      //kalau user bukan dealer, return undefined
      var tempDealer = this.$store.getters["dealer/getCurrentDealers"];

      if (tempDealer === null) {
        tempDealer = this.dealerChoice;
        //this.defineDealer();
      }
      return tempDealer;
    },
    cartTotalPrice: {
      //kalkulasi subtotal
      get() {
        const total = this.form.items.reduce((acc, current) => {
          // Skip items with no model or price
          if (!current.itemModel || (!current.price && !current.priceReplacement)) {
            return parseFloat(acc);
          }
          
          // Convert price to number if it's a MongoDB decimal
          let currentPrice = current.price;
          if (typeof currentPrice === 'object' && currentPrice.$numberDecimal) {
            currentPrice = parseFloat(currentPrice.$numberDecimal);
          }
          
          // For items using replacement (when status is Replacement Item Safe)
          if (current.status === 'Replacement Item Safe' && current.replacementItem && 
              (current.availableReplacementQty > 0 || current.availableReplacementQty !== undefined)) {
            const replacementPrice = current.totalPriceReplacement ? parseFloat(current.totalPriceReplacement) : 0;
            return parseFloat(acc) + replacementPrice;
          }
          
          // For regular items with stock or no stock info yet (initial load)
          if (!current.hasReplacement && (current.availableQty > 0 || current.availableQty === undefined || current.qty > 0)) {
            // Handle both string and object totalPrice formats
            let itemPrice = 0;
            if (current.totalPrice) {
              if (typeof current.totalPrice === 'object' && current.totalPrice.$numberDecimal) {
                itemPrice = parseFloat(current.totalPrice.$numberDecimal);
              } else {
                itemPrice = parseFloat(current.totalPrice);
              }
            } else if (currentPrice && (current.updatedQty || current.qty)) {
              // Fallback calculation if totalPrice isn't set
              const quantity = current.updatedQty || current.qty || 0;
              itemPrice = currentPrice * quantity;
            }
            return parseFloat(acc) + itemPrice;
          }
          
          return parseFloat(acc);
        }, 0);
        
        return this.formatter(parseFloat(total));
      },
      set(val) {
        return;
      },
    },
    cartTotalDiscount: {
      //kalkulasi total discount
      get() {
        let totalPriceBase = this.form.items.reduce((acc, current) => {
          // Skip items with no model or price
          if (!current.itemModel || (!current.price && !current.priceReplacement)) {
            return parseFloat(acc);
          }
          
          // For items using replacement
          if (current.status === 'Replacement Item Safe' && current.replacementItem && 
              (current.availableReplacementQty > 0 || current.availableReplacementQty !== undefined)) {
            const quantity = parseFloat(current.updatedReplacementQty || current.availableReplacementQty || 0);
            const totalPrice = parseFloat(current.priceReplacement || 0) * quantity;
            return parseFloat(acc) + totalPrice;
          }
          
          // For regular items with stock
          if (!current.hasReplacement && (current.availableQty > 0 || current.availableQty !== undefined)) {
            const quantity = parseFloat(current.updatedQty || current.qty || 0);
            const totalPrice = parseFloat(current.price || 0) * quantity;
            return parseFloat(acc) + totalPrice;
          }
          
          return parseFloat(acc);
        }, 0);

        // Calculate discount percentage
        const discountPercentage = totalPriceBase > 0 ? 
                                ((totalPriceBase - this.cartTotalPrice) / totalPriceBase) * 100 : 0;
                            
        return this.formatter(parseFloat(discountPercentage));
      },
      set(val) {
        return;
      },
    },
    cartTotalBeforeDiscount: {
      //kalkulasi subtotal before discount
      get() {
        let totalPriceBase = this.form.items.reduce((acc, current) => {
          // Skip items with no model or price
          if (!current.itemModel || (!current.price && !current.priceReplacement)) {
            return parseFloat(acc);
          }
          
          // For items using replacement
          if (current.status === 'Replacement Item Safe' && current.replacementItem && 
              (current.availableReplacementQty > 0 || current.availableReplacementQty !== undefined)) {
            const quantity = parseFloat(current.updatedReplacementQty || current.availableReplacementQty || 0);
            const totalPrice = parseFloat(current.priceReplacement || 0) * quantity;
            return parseFloat(acc) + totalPrice;
          }
          
          // For regular items with stock
          if (!current.hasReplacement && (current.availableQty > 0 || current.availableQty !== undefined)) {
            const quantity = parseFloat(current.updatedQty || current.qty || 0);
            const totalPrice = parseFloat(current.price || 0) * quantity;
            return parseFloat(acc) + totalPrice;
          }
          
          return parseFloat(acc);
        }, 0);
        
        return this.formatter(parseFloat(totalPriceBase));
      },
      set(val) {
        return;
      },
    },
    cartTotal() {
      //kalkulasi total price
      return this.formatter(parseFloat(this.cartTotalPrice) + parseFloat(this.gstTotal));
    },
    gstTotal() {
      //ini nanti akan ada update GST sesuai settings. CR
      let valuePercent = this.currentGST.value / 100;
      let gstValue = this.cartTotalPrice * valuePercent;
      return this.formatter(parseFloat(gstValue));
    },
    discountAmountFormatter() {
      return (item, index) => {
        const key = this.getItemKey(index, item);
        const editState = this.editingStates.discountAmounts[key];
        
        if (editState && editState.editing) {
          return editState.tempValue !== undefined ? editState.tempValue : this.parseToNumber(item.discountAmount);
        }
        return this.formatter(item.discountAmount);
      };
    },
    
    discountAmountReplacementFormatter() {
      return (item, index) => {
        const key = this.getItemKey(index, item);
        const editState = this.editingStates.discountAmountsReplacement[key];
        
        if (editState && editState.editing) {
          return editState.tempValue !== undefined ? editState.tempValue : this.parseToNumber(item.discountAmountReplacement);
        }
        return this.formatter(item.discountAmountReplacement);
      };
    },
  },
  beforeDestroy() {
    // Clean up any remaining editing states to prevent memory leaks
    this.editingStates = {
      discountAmounts: {},
      discountAmountsReplacement: {}
    };
  },
};
</script>

<style>
.deliveryUnitNo-ekiosk {
  width: 100px;
}
.cart__area-ekiosk {
  display: flex;
  flex-direction: column;
}

.cart__area-body-ekiosk {
  grid-template-rows: 100%;
  overflow-x: scroll;
  margin: 10px 0;
}

.cart__area-columns-ekiosk {
  display: grid;
  grid-template-columns: auto 5% 10% 10% 10% 10% 10% 15% 5%;
  column-gap: 15px;
  margin: 0 0 5px 0;
  padding: 8px 5px;
  border-radius: 4px;
}

/* Color coding for item status */
.cart__area-columns-ekiosk.out-of-stock-ekiosk {
  background-color: #FF687C;
}

.cart__area-columns-ekiosk.replacement-safe-ekiosk {
  background-color: #FFC584;
}

.cart__area-info-ekiosk {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}

.cart__area-line-info-ekiosk {
  display: flex;
  align-items: center;
  margin: 0 0 5px 0;
}

.cart__area-line-info-ekiosk span {
  width: 100%;
  margin: 0 5px 0 0;
}

.cart__area-line-info-ekiosk input {
  width: 100px;
}

.cart-area-columns-ekiosk span {
  font-weight: bold;
}

.v-select .vs__dropdown-toggle {
  height: 2.714rem;
  padding: 0;
}

.qty-wrapper-ekiosk {
  display: flex;
  flex-direction: column;
  min-height: 66px; /* Sesuaikan agar seimbang dengan input lainnya */
  justify-content: flex-end;
}

.cart__area-columns-ekiosk > div {
  min-height: 44px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

@media only screen and (max-width: 681px) {
  .cart__area-columns-ekiosk {
    display: none;
  }
}

@media only screen and (min-width: 682px) {
  .cart__area-columns_mobile-ekiosk {
    display: none;
  }
}
</style>
